import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { useI18nContext } from "@hopper-b2b/i18n";
import {
  Button,
  ButtonTypeEnum,
  Dialog,
  DialogContent,
  DialogTrigger,
  Icon,
} from "@tenant/ui";
import clsx from "clsx";
import type { ButtonConfig } from "../MobileCheckoutPage";
import styles from "./CollapsiblePriceBottomSection.module.scss";

export interface CollapsiblePriceBottomSectionProps {
  amountDue: string | undefined;
  priceBreakdownContent: React.ReactNode;
  buttons: ButtonConfig[];
  hidePriceBreakdown?: boolean;
  errorMessage?: string;
}

export const CollapsiblePriceBottomSection = ({
  amountDue = "",
  priceBreakdownContent,
  buttons,
  hidePriceBreakdown = false,
  errorMessage,
}: CollapsiblePriceBottomSectionProps) => {
  const [block, cn] = useModuleBEM(styles, "CollapsiblePriceBottomSection");
  const { t } = useI18nContext();

  return (
    <div className={block}>
      {!hidePriceBreakdown && (
        <Dialog>
          <DialogTrigger asChild>
            <button
              className={cn("trigger")}
              aria-label={t("checkout.priceBreakdownAriaLabel")}
            >
              <span className={cn("label")}>{t("core-ui.tripTotal")}</span>
              <div className={cn("price-wrapper")}>
                <span className={cn("value")}>{amountDue}</span>
                <Icon
                  className={cn("chevron")}
                  iconName={IconNameEnum.chevronDown}
                  useCurrentColor
                />
              </div>
            </button>
          </DialogTrigger>
          <DialogContent
            title={t("checkoutBreakdown")}
            className={cn("modal-content")}
          >
            {priceBreakdownContent}
          </DialogContent>
        </Dialog>
      )}
      {errorMessage && (
        <span className={cn("error-message")}>{errorMessage}</span>
      )}
      <div className={cn("buttons-wrapper")}>
        {buttons.map(({ label, onClick, disabled, props }, index) => (
          <Button
            buttonType={ButtonTypeEnum.Primary}
            key={`button-${index}`}
            onClick={onClick}
            disabled={disabled}
            {...props}
            className={clsx(cn("button"), props?.className)}
          >
            {label}
          </Button>
        ))}
      </div>
    </div>
  );
};
